module.exports = __webpack_public_path__ + "img/Kevin_Kimble.a97acbb9.jpg";